import { Grid, Paper, Skeleton } from "@mui/material";

const SSkeletonGrid = ({ columns, rows, height }) => (
  <Grid container spacing={1}>
    {Array.from({ length: rows * columns }).map((_, index) => (
      <Grid size={12 / columns} key={`skeleton-cell-${index}`}>
        <Skeleton variant="rectangular" animation="wave" height={height} sx={{ borderRadius: "4px" }} />
      </Grid>
    ))}
  </Grid>
);

const SSkeletonLoader = ({ rows = 10, height = 43 }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 9 }}>
        <Paper sx={{ p: 2 }}>
          <SSkeletonGrid columns={3} rows={rows} height={height} />
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <Paper sx={{ p: 2 }}>
          <SSkeletonGrid columns={2} rows={rows} height={height} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default SSkeletonLoader;
